import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Common } from 'ws-scripts/modules/common';
import HighlightedFeatures from '../components/HighlightedFeatures';

export class WidgetContainer extends React.Component {
	render() {
		const featureArray = this.props.features;
		const featureCount = featureArray.length;
		const rootComponent = (
			<Common
				render={({ prefs }) => {
					if (featureCount > prefs.maxHighlightedFeatures) {
						featureArray.splice(prefs.maxHighlightedFeatures);
					}
					return <HighlightedFeatures features={featureArray} />;
				}}
			/>
		);
		return rootComponent;
	}
}

WidgetContainer.propTypes = {
	features: PropTypes.arrayOf(PropTypes.array).isRequired
};

const mapStateToProps = state => {
	return {
		features: state.features
	};
};

const mapDispatchToProps = _dispatch => ({});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(WidgetContainer);
